import PropTypes from "prop-types";
import {
  MoreHorizontal, History, Pencil, Power, Trash2,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

export function ContactActionMenu({
  status,
  onViewHistory,
  onEdit,
  onToggleInactive,
  onDelete,
  align = "end",
}) {
  const inactive = status === "inactive";
  // View History is optional: contact cards expose a dedicated primary button,
  // so the overflow menu omits it there to avoid duplicate entry points.
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex h-10 w-10 sm:h-7 sm:w-7 items-center justify-center rounded-md text-slate-400",
            "hover:bg-slate-100 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-200",
          )}
          data-testid="contact-actions-trigger"
          aria-label="Contact actions"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal size={15} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className="min-w-[180px] rounded-xl border-slate-200 p-1.5 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {typeof onViewHistory === "function" ? (
          <DropdownMenuItem
            className="rounded-lg gap-2 text-[12.5px] cursor-pointer"
            onSelect={onViewHistory}
            data-testid="contact-action-history"
          >
            <History size={14} className="text-slate-500" />
            View History
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuItem
          className="rounded-lg gap-2 text-[12.5px] cursor-pointer"
          onSelect={onEdit}
          data-testid="contact-action-edit"
        >
          <Pencil size={14} className="text-slate-500" />
          Edit Contact
        </DropdownMenuItem>
        <DropdownMenuItem
          className="rounded-lg gap-2 text-[12.5px] cursor-pointer"
          onSelect={onToggleInactive}
          data-testid="contact-action-inactive"
        >
          <Power size={14} className="text-slate-500" />
          {inactive ? "Mark as Active" : "Mark as Inactive"}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="rounded-lg gap-2 text-[12.5px] cursor-pointer text-rose-600 focus:text-rose-700 focus:bg-rose-50"
          onSelect={onDelete}
          data-testid="contact-action-delete"
        >
          <Trash2 size={14} className="text-rose-600" />
          Delete Contact
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

ContactActionMenu.propTypes = {
  status: PropTypes.oneOf(["active", "inactive"]),
  onViewHistory: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onToggleInactive: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  align: PropTypes.string,
};
